import Swal from "sweetalert2";
import { BiChevronDown } from "react-icons/bi";
// import { useEffect } from "react";

import Dropdown from "../../../components/Dropdown";
import Modal from "../../../components/modal";
import { useModal } from "../../../customHooks/useModal";

import { useAppDispatch } from "../../../store/hooks";
import { roles, deleteRole } from "../../../store/roles_skills";
import EditRole from "./edit/index";
import AddSkills from "./addSkills/AddSkills";

interface Props {
  role: roles;
}

const OneRole = ({ role }: Props) => {
  const dispatch = useAppDispatch();

  const { isShown: isModalShown, toggle: ToggleModal } = useModal();
  const { isShown: isAddSkillShown, toggle: ToggleModalSkills } = useModal();

  const delRole = () => {
    Swal.fire({
      title: "You are about to delete a role",
      text: "This change can't be reversed",
      icon: "warning",
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: "Yes, confirm",
    }).then((isConfirmed) => {
      if (isConfirmed.isConfirmed) {
        console.log(role.id_encrypted);
        dispatch(deleteRole({ id_encrypted: role.id_encrypted }));
      }
    });
  };

  const Optiosn = (
    <div className="c-list-options">
      <span className="c-list-options__item" onClick={ToggleModal}>
        Edit Role
      </span>
      <span className="c-list-options__item" onClick={delRole}>
        Delete Role
      </span>
      <span className="c-list-options__item" onClick={ToggleModalSkills}>
        Add Skills
      </span>
    </div>
  );
  return (
    <>
      <Modal isActive={isModalShown} clouse={ToggleModal} title="Edit Role">
        <EditRole isShown={isModalShown} role={role} toggle={ToggleModal} />
      </Modal>
      <Modal
        isActive={isAddSkillShown}
        clouse={ToggleModalSkills}
        title="Add or Remove Skills"
      >
        <AddSkills
          isShown={isAddSkillShown}
          role={role}
          toggle={ToggleModalSkills}
        />
      </Modal>
      <tr>
        {/*  <td className="c-table__trbody"><input type="checkbox" id="cbox1" value="first_checkbox" /></td> */}
        <td className="c-table__trbody">{role.id}</td>
        <td className="c-table__trbody">{role.role}</td>
        <td className="c-table__trbody">{role.slug}</td>
        <td className="c-table__trbody">
          {role.skills.map((skill) => (
            <div key={skill.id_encrypted}>{skill.slug}</div>
          ))}
        </td>
        <td className="c-table__trbody">
          <Dropdown overlay={Optiosn} placement="bottom-end" margin={0}>
            <button className="c-table__actions">
              Actions <BiChevronDown />
            </button>
          </Dropdown>
        </td>
      </tr>
    </>
  );
};

export default OneRole;
